import { parentesco } from '@utils';
import {
  casoUniaoEstavel,
  certidaoGenitor,
  childs,
  commons,
  concessionLetterINSS,
  convivente,
  death,
  others,
  parents,
  specialChild,
  spouses,
  termoTutelaJudicial,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

const { constants } = parentesco;

export const RCMBDocs = () => {
  const rules = {
    anexoOutros: dynamicRule(),
    anexoCertidaoDeObito: dynamicRule('required'),
    anexoCertidaoCasamentoOuNascimento: dynamicRule('pais'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCartaConcessaoINSS: dynamicRule(),
    anexoCertidaoCasamento: dynamicRule('casamento'),
    anexoCertidaoNascimento: dynamicRule('nascimento'),
    anexoLaudoMedico: dynamicRule('laudoMedico'),

    anexoConvivente: dynamicRule('convivente'),
    anexoCasoUniaoEstavel: dynamicRule(),

    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),
    anexoQuaisquerOutros: dynamicRule(),
    anexoTermoTutelaJudicial: dynamicRule('menorTutelaAdd'),
  };
  const docs = {
    commons: [...commons],
    others: [...others],
    [constants.PAI]: [...death, ...concessionLetterINSS, ...parents],
    [constants.MAE]: [...death, ...concessionLetterINSS, ...parents],
    [constants.CONJUGE]: [...death, ...concessionLetterINSS, ...spouses],
    [constants.EX_CONJUGE]: [...death, ...concessionLetterINSS, ...spouses],
    [constants.FILHO]: [...death, ...concessionLetterINSS, ...childs],
    [constants.MENOR_TUTELA]: [
      ...childs,
      ...termoTutelaJudicial,
      ...death,
      ...concessionLetterINSS,
    ],
    [constants.FILHO_ESPECIAL]: [
      ...death,
      ...concessionLetterINSS,
      ...childs,
      ...specialChild,
    ],
    [constants.CONVIVENTE]: [
      ...death,
      ...concessionLetterINSS,
      ...convivente,
      ...casoUniaoEstavel,
    ],
    [constants.ENTEADO]: [
      ...death,
      ...concessionLetterINSS,
      ...childs,
      ...certidaoGenitor,
    ],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
